<template>
  <section class="contrato-form-section">
    <h6 class="contrato-form-section-title"><i class="fa-solid fa-video me-2"></i>Videos (enlaces)</h6>
    <div class="row g-2 mb-2">
      <div class="col-md-4">
        <label class="form-label small mb-0">Nombre del video</label>
        <input v-model="nuevoVideoNombre" type="text" class="form-control form-control-sm"
          placeholder="Ej. intro, comida, baile">
      </div>
      <div class="col-md-6">
        <label class="form-label small mb-0">URL</label>
        <input v-model="nuevoVideoUrl" type="url" class="form-control form-control-sm" placeholder="https://...">
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <button type="button" class="btn btn-outline-primary btn-sm w-100" @click="agregarVideo"
          :disabled="!nuevoVideoUrl.trim()">
          <i class="fa-solid fa-plus me-1"></i>Agregar
        </button>
      </div>
    </div>
    <div v-if="form.videosLista.length">
      <div v-for="(v, idx) in form.videosLista" :key="idx"
        class="video-row mb-2 d-flex flex-wrap gap-2 align-items-end">
        <div class="flex-grow-1" style="min-width: 140px;">
          <label class="form-label small mb-0">Nombre del video</label>
          <input v-model="v.nombre" type="text" class="form-control form-control-sm"
            placeholder="Ej. intro, comida, baile">
        </div>
        <div class="flex-grow-1" style="min-width: 200px;">
          <label class="form-label small mb-0">URL</label>
          <input v-model="v.url" type="url" class="form-control form-control-sm" placeholder="https://...">
        </div>
        <div class="d-flex gap-2">
          <a v-if="v.url.trim()" :href="v.url" target="_blank" rel="noopener" class="btn btn-outline-secondary btn-sm"
            title="Abrir">
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </a>
          <button type="button" class="btn btn-outline-danger btn-sm" title="Quitar" @click="quitarVideo(idx)">
            <i class="fa-solid fa-minus"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { ContratoFormState } from '@/types/contrato';

const props = defineProps<{
  form: ContratoFormState;
}>();

const nuevoVideoNombre = ref('');
const nuevoVideoUrl = ref('');

function agregarVideo() {
  const url = nuevoVideoUrl.value.trim();
  if (url) {
    props.form.videosLista.push({
      nombre: nuevoVideoNombre.value.trim() || `Video ${props.form.videosLista.length + 1}`,
      url
    });
    nuevoVideoNombre.value = '';
    nuevoVideoUrl.value = '';
  }
}

function quitarVideo(idx: number) {
  props.form.videosLista.splice(idx, 1);
}
</script>
